import { GitHubAuthorizationState } from '@gonfalon/observability-graphql/schemas';

export { GitHubAuthorizationState };

export function isGitHubUserAuthorized(
  authorizationState: GitHubAuthorizationState | null | undefined,
  userTokenValid: boolean | null | undefined,
): boolean {
  if (authorizationState) {
    return authorizationState === GitHubAuthorizationState.Authorized;
  }
  return !!userTokenValid;
}

export type BlockedGitHubAuthorization =
  | 'not-authorized'
  | 'installation-inaccessible'
  | 'github-unavailable'
  | 'authorization-unknown';

export function blockedGitHubAuthorization(
  authorizationState: GitHubAuthorizationState | null | undefined,
): BlockedGitHubAuthorization {
  switch (authorizationState) {
    case GitHubAuthorizationState.InstallationNotAccessible:
      return 'installation-inaccessible';
    case GitHubAuthorizationState.GithubUnavailable:
      return 'github-unavailable';
    case GitHubAuthorizationState.TokenLookupFailed:
      return 'authorization-unknown';
    default:
      return 'not-authorized';
  }
}
